<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>FİNANS ÖZET TABLOSU</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#"></a></li>
        </ul>
      </div>
      <div>
        <button @click="routeAddNote()" type="button" class="btn btn-success">ÇEK LİSTESİ</button>
      </div>
      <div class="row center">
        <div class="col-md-6 -webkit-scrollbar ">
          <div class="hr-title-home hr-long center">
            <abbr>
              <h2>YAPILACAKLAR</h2>
            </abbr>
          </div>
          <div class="tileHomepage" style="height: 850px; overflow-y: overlay">
            <div class="col-sm-12 sidenav">
              <div v-for="(item, index) in result" :key="index" class="col-md-12 col-lg-12 hower1"
                style="margin-bottom: 10px" v-if="result[index].status == 0">
                <div v-if="result[index].user_id == buttonid" style="color : red">
                  <br />
                  <a @click="routeDetailNotifications(item.id)" style="font-size: 14px " class="readmore">
                    <div class="block-blog text-left">
                      <div class="content-blog">
                        <a style="font-size: 14px" class="readmore" v-html="'<div>' + item.title + '</div>'"></a>
                        <p style="
                      overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                  " v-html="'<div>' + item.content + '</div>'"></p>
                    <p>{{ item.user_name }}</p>
                        <p>{{ item.reg_date }}</p>
                        <hr />
                      </div>
                    </div>

                  </a>
                </div>
                <div v-if="result[index].user_id != buttonid">
                  <br />
                  <a @click="routeDetailNotifications(item.id)" style="font-size: 14px " class="readmore">
                    <div class="block-blog text-left">
                      <div class="content-blog">
                        <a style="font-size: 14px" class="readmore" v-html="'<div>' + item.title + '</div>'"></a>
                        <p style="
                      overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                  " v-html="'<div>' + item.content + '</div>'"></p>
                        <p>{{ item.user_name }}</p>
                        <p>{{ item.reg_date }}</p>
                        <hr />
                      </div>
                    </div>

                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 -webkit-scrollbar ">
          <div class="hr-title-home hr-long center">
            <abbr>
              <h2>TAMAMLANANLAR</h2>
            </abbr>
          </div>
          <div class="tileHomepage" style="height: 850px; overflow-y: overlay">
            <div class="col-sm-12 sidenav">
              <div v-for="(item, index) in result" :key="index" class="col-md-12 col-lg-12 hower2"
                style="margin-bottom: 10px" v-if="result[index].status == 1">
                <br />
                <a @click="routeDetailNotifications(item.id)" style="font-size: 14px" class="readmore">
                  <div class="block-blog text-left">
                    <div class="content-blog">
                      <a style="font-size: 14px" class="readmore" v-html="'<div>' + item.title + '</div>'"></a>
                      <p style="
                      overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                  " v-html="'<div>' + item.content + '</div>'"></p>
                      <p>{{ item.user_name }}</p>
                      <p>{{ item.reg_date }}</p>
                      <hr />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";

export default {
  data() {
    return {
      buttonid: "",
      result: [],
      result2: [],
      situation: false,
      img_base_url: store.state.img_base_url,
    };
  },
  methods: {
    routeAddNote: function () {
      this.$router.push("addNotice");
    },
    reload: function () {
      location.reload();
    },
    routeDetailNotices: function (itemId) {
      window.location.href = "#/noticesDetail?id=" + itemId;
    },
    routeDetailNotifications: function (itemId) {
      window.location.href = "#/notificationsDetail?id=" + itemId;
    },
  },

  mounted: function () {
    let datas = [];
    this.buttonid = localStorage.getItem("id");
    let url = store.state.base_url + "AslanSahalar/getByIdNotifications.php?key=123";
    var sendData = {
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
    };

    axios
      .post(url, JSON.stringify(sendData))
      .then((response) => {
        this.result = response.data.data;
        // console.log(this.result)
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>
<style scoped>
.hower1:hover {
  background: #c1163b;

  color: white;
}

.hower2:hover {
  background: #1bbd0d;

  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/FinanceMain.vue